<template>
  <div
    class="notification-container"
    @click="getNotifications"
  >
    <div class="bell-icon-container">
      <a href="#">
        <img
          id="bell-icon"
          src="../../../images/bell-icon.svg"
          alt=""
        >
        <sup
          v-if="newNotificationCount !== 0 && newNotificationCount < 10"
          class="notification-count"
        >{{ newNotificationCount }}</sup>
        <sup
          v-if="newNotificationCount > 9"
          class="notification-count"
        >9+</sup>
      </a>
    </div>
    <div
      class="list-notification-container"
      :class="{hidden: !showContent}"
    >
      <LoadingSpinner v-if="loading" />
      <ul class="notification-ul">
        <template v-if="newNotifications.length > 0">
          <router-link
            v-for="notification in newNotifications"
            :key="notification.id"
            :to="{
              name: 'QuestionDetail',
              params: { id: notification.action === 'posted' ? notification.notifiable_id : notification.q_id}
            }"
            class="notification-list"
          >
            <li
              class="notification"
              :class="{unread: notification.read_at == null}"
            >
              {{ determineText(notification) }}
            </li>
          </router-link>
        </template>
        <li
          v-else
          class="notification"
        >
          No new notifications
        </li>
        <router-link to="/notification">
          <li class="notification remove-border orange-text view-all">
            View All
          </li>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '../../LoadingAnimations/LoadingSpinner.vue'
import {onMounted, computed, ref} from 'vue'
import {useNotificationStore} from '@/store'

export default {
  components: {
    LoadingSpinner,
  },
  setup() {
    const notificationStore = useNotificationStore()
    const showContent = ref(false)
    const notifications = ref([])

    onMounted(async () => {
      await notificationStore.getNewNotificationCount()
    })

    const newNotificationCount = computed(() => notificationStore.newNotificationCount)

    const toggleCard = () => {
      showContent.value =!showContent.value
    }

    const getNotifications = async (event) => {
      event.preventDefault()
      toggleCard()
      if (showContent) {
        await notificationStore.getReadNotification()
        await notificationStore.getNewNotification()
      }
    }

    const newNotifications = computed(() => notificationStore.allNewNotifications)
    const loading = computed(() => notificationStore.loading)

    const determineText = (notification) => {
      switch (notification.action) {
        case 'answered':
          return `Adv. ${notification.user.first_name} answered your question`

        case 'commented':
          if (notification.user.is_lawyer) return `Adv. ${notification.user.first_name} commented on your comment`
        return `${notification.user.username} commented on your answer.`

        case 'posted':
          return `${notification.user.username} posted a question`
      }
    }
    return {
      newNotificationCount,
      showContent,
      notifications,
      newNotifications,
      loading,
      determineText,
      getNotifications,
    }
  },
}
</script>
